declare var window: any;
declare var gtag: any;

export const sanObj = {
    callGA_action: (window.sanObj && window.sanObj.callGA_action) ?
        window.sanObj.callGA_action :
        (action: any, category: any, label: any) => {
            // console.warn('callGA_action not found');
            // if (typeof gtag !== 'undefined')
            //     gtag('event', action, {
            //         'event_category': category,
            //         'event_label': label,
            //     });
        },
    trackingAdfClick: (window.sanObj && window.sanObj.trackingAdfClick) ?
        window.sanObj.trackingAdfClick :
        (params: any) => {
            // console.warn('trackingAdfClick not found');
            window.adf && window.adf.ClickTrack && window.adf.ClickTrack(this, 1404471, 'Santander|' + params, {});
        },

    trackingView: (params: any, count: number = 0) => {
        console.info('sanObj trackingView params', params, ' count ', count);
        if (window.sanObj && window.sanObj.trackingView) {
            window.sanObj.trackingView(params)
        }
        else if (count < 10)
            return setTimeout(() => {
                return sanObj.trackingView(params, count + 1)
            }, 500);
        else {
            console.warn('trackingView not found');
            window._adftrack = Array.isArray(window._adftrack) ? window._adftrack :
                (window._adftrack ? [window._adftrack] : []);
            window._adftrack.push(params);
            (function () {
                var s = document.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = 'https://track.adform.net/serving/scripts/trackpoint/async/';
                var x = document.getElementsByTagName('script')[0]; x.parentNode.insertBefore(s, x);
            })();
        }
    },
}